import { createRoute } from "@tanstack/react-router";

import { requirePermission } from "@platform/auth/guards";
import { shellRoute } from "@platform/shell.route";
import { MemoryPage } from "./memory.page";

export const memoryRoute = createRoute({
	getParentRoute: () => shellRoute,
	path: "/memory",
	beforeLoad: ({ context }) => requirePermission(context.queryClient, { memory: ["read"] }),
	component: MemoryPage,
});
